import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import Navigation from './components/navigation';
import Header from './components/header';
import MyFooter from './components/myfooter';
import MyPage from './components/mypage';

import 'bootstrap/dist/css/bootstrap.css';


ReactDOM.render(<MyPage />, document.getElementById('root'));
//ReactDOM.render(<Header />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
